// frontend/src/landing/LandingLayout.tsx
import React from "react";
import "./landing.css";

import iconLight from "./assets/icon-light.png";
import iconDark from "./assets/icon-dark.png";
import Brand from "./components/Brand";
import HeroSection from "./sections/HeroSection";
import ProblemSection from "./sections/ProblemSection";
import SolutionSection from "./sections/SolutionSection";
import CaseStudySchoolSection from "./sections/CaseStudySchoolSection";
import CaseStudyClinicSection from "./sections/CaseStudyClinicSection"; 
import PricingSection from "./sections/PricingSection";
import SecuritySection from "./sections/SecuritySection";
import FooterSection from "./sections/FooterSection";

export type LandingLayoutProps = {
  isAuthenticated: boolean;
  userEmail: string;
  booting: boolean;
  projectId: number | null;
  bootError: string | null;

  verifyEmailError: boolean;

  onSignup: () => void;
  onLogin: () => void;
  onContinueAfterVerify: () => void;
  onDismissVerifyEmailBanner: () => void;
};

export default function LandingLayout(props: LandingLayoutProps) {
  return (
    <div className="zg-landing" id="top">
      <header className="zg-header">
        <div className="zg-container zg-header-inner">
          <a className="zg-brand" href="/" aria-label="zeitgeist Start">
            <picture>
              <source media="(prefers-color-scheme: dark)" srcSet={iconDark} />
              <img className="zg-brand-icon" src={iconLight} alt="zeitgeist" />
            </picture>
            <span className="zg-brand-name">
              zeitgeist
            </span>
          </a>

          <nav className="zg-nav">
            <button type="button" className="zg-nav-linkbutton" onClick={props.onSignup}>
              mitmachen
            </button>
            <button type="button" className="zg-nav-linkbutton" onClick={props.onLogin}>
              weitermachen
            </button>
          </nav>
        </div>
      </header>

      {props.verifyEmailError ? (
        <div className="zg-verify" role="alert" aria-live="polite">
          <div className="zg-verify-inner zg-container">
            <div className="zg-verify-title">Bitte E-Mail verifizieren</div>
            <div className="zg-verify-text">
              Wir haben eine Verifizierungs-Mail geschickt. Bitte auch Spam prüfen. Danach können Sie sich einloggen.
            </div>
            <div className="zg-verify-actions">
              <button type="button" className="zg-btn primary" onClick={props.onContinueAfterVerify}>
                Ich habe verifiziert – weiter
              </button>
              <button type="button" className="zg-btn ghost" onClick={props.onDismissVerifyEmailBanner}>
                Schließen
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <main>
        <HeroSection {...props} />
        <div className="zg-divider" />
        <ProblemSection />
        <div className="zg-divider" />
        <SolutionSection />
        <div className="zg-divider" />
        <CaseStudySchoolSection />
        <div className="zg-divider" />
        <CaseStudyClinicSection />
        <div className="zg-divider" />
        <PricingSection onSignup={props.onSignup} />
        <div className="zg-divider" />
        <SecuritySection />
      </main>

      <FooterSection />
    </div>
  );
}